export const FLAG_APPLICABILITY_OPTIONS = [
  { value: 'entry', label: 'Entry only', applyOnEntry: true, applyOnExit: false },
  { value: 'exit', label: 'Exit only', applyOnEntry: false, applyOnExit: true },
  { value: 'both', label: 'Entry & exit', applyOnEntry: true, applyOnExit: true },
];
export const hasFlagApplicability = flag => Boolean(flag &&
  typeof flag.applyOnEntry === 'boolean' && typeof flag.applyOnExit === 'boolean');
export const flagApplicabilityValue = flag => hasFlagApplicability(flag) ?
  (FLAG_APPLICABILITY_OPTIONS.find(option => option.applyOnEntry === flag.applyOnEntry && option.applyOnExit === flag.applyOnExit) || {}).value : undefined;
export const flagApplicabilityLabel = flag => !hasFlagApplicability(flag) ? 'Not available' :
  (FLAG_APPLICABILITY_OPTIONS.find(option => option.value === flagApplicabilityValue(flag)) || {}).label || 'Invalid configuration: neither direction';
export const flagApplicabilityFields = value => {
  const option = FLAG_APPLICABILITY_OPTIONS.find(item => item.value === value);
  if (!option) throw new Error('Choose Entry only, Exit only, or Entry and exit.');
  return { applyOnEntry: option.applyOnEntry, applyOnExit: option.applyOnExit };
};
export const confirmFlagApplicability = (flag, request, expectedFlagId) => {
  if (!hasFlagApplicability(flag) || flag.applyOnEntry !== request.applyOnEntry || flag.applyOnExit !== request.applyOnExit ||
      (expectedFlagId !== undefined && flag.flagId !== expectedFlagId)) {
    const error = new Error('BACKEND NOT YET AVAILABLE: the saved applicability was not confirmed. The flag request may have succeeded; do not submit it again. Reload and verify the backend definition DTO contract.');
    error.code = 'FLAG_APPLICABILITY_UNVERIFIED';
    error.savedFlagId = expectedFlagId || (flag && flag.flagId);
    throw error;
  }
  return flag;
};
